/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const LetterOfCreditDetailPage = lazyLoad(
  () => import('./index'),
  module => module.LetterOfCreditDetailPage,
);
